import 'whatwg-fetch'
import Vue from 'vue'
import App from './App.vue'
import LocalDocs from './components/LocalDocs'
import FinDocs from './components/fin_docs/index'
import SelfExaminationReport from './components/selfExaminationReport'
import store from './store'
import ApiService from './common/api.service'
import ParentPay from './components/fin_docs/parentPay'
import DocReview from "./components/DocReview";
import EducationPaid from "./components/EducationPaid";
import DocsFromApi from "./components/DocsFromApi";

Vue.config.productionTip = false
ApiService.init()
store.commit('setEoId', document.body.getAttribute('data-eo-id'))

if (document.getElementById('app-page-right-docs')) {
  new Vue({
    store,
    render: h => h(App)
  }).$mount('#app-page-right-docs')
}

if (document.getElementById('app-local-docs')) {
  new Vue({
    store,
    render: h => h(LocalDocs)
  }).$mount('#app-local-docs')
}

if (document.getElementById('app-fin-docs')) {
  new Vue({
    store,
    render: h => h(FinDocs)
  }).$mount('#app-fin-docs')
}

if (document.getElementById('app-self-examination-report')) {
  new Vue({
    store,
    render: h => h(SelfExaminationReport)
  }).$mount('#app-self-examination-report')
}

if (document.getElementById('app-parent-pay-docs')) {
  new Vue({
    store,
    render: h => h(ParentPay)
  }).$mount('#app-parent-pay-docs')
}


if (document.getElementById('app-page-doc-review')) {
  new Vue({
    store,
    render: h => h(DocReview)
  }).$mount('#app-page-doc-review')
}

if (document.getElementById('app-parent-pay-other-docs')) {
  new Vue({
    store,
    render: h => h(EducationPaid)
  }).$mount('#app-parent-pay-other-docs')
}

if (document.getElementById('app-docs-from-api')) {
  const element = document.getElementById('app-docs-from-api')
  new Vue({
    store,
    render: h => h(DocsFromApi),
    propsData: {...element.dataset},
    props: {
      slug: String
    }
  }).$mount('#app-docs-from-api')
}
